<template>
    <b-button
        class="mb-2 px-1 py-0 mr-1"
        variant="primary"
        size="lg"
        @click="downloadFile"
        title="Download Import"
    >
       <i class="fa fa-download"></i> <p v-if="!isAction">Download Import File</p>
    </b-button>
</template>
<script>
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";

const ResultImportRepository = LabRepositoryFactory.get("resultImport");

export default {
    name: "DownloadResultImportFile",
    mixins: [ToastNotifications],
    props: {
        resultImportID: {
            type: String,
            required: true
        },
        isAction: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async downloadFile() {
            await ResultImportRepository.download(this.resultImportID).then(
              (response) => {
                var fileURL = window.URL.createObjectURL(
                  new Blob([Buffer.from(response.data.file, "base64")])
                );
                var fURL = document.createElement("a");

                fURL.href = fileURL;
                fURL.setAttribute("download", response.data.file_name);
                document.body.appendChild(fURL);

                fURL.click();
              }
            ).catch((error) => {
                this.quickDangerToast('Unable to download this file', error)
            });
        },
    },
}
</script>